"use strict";

exports.__esModule = true;
exports.TooltipWrapper = exports.Tooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _TimeContext = require("../../../../Time/TimeContext");
var _StandardTooltip = require("./StandardTooltip");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TooltipWrapper = exports.TooltipWrapper = function TooltipWrapper(props) {
  var _props$enableTooltip = props.enableTooltip,
    enableTooltip = _props$enableTooltip === void 0 ? true : _props$enableTooltip,
    tooltipProps = props.tooltipProps;
  return enableTooltip ? /*#__PURE__*/_react["default"].createElement(Tooltip, _extends({
    isActive: tooltipProps.isOpen
  }, tooltipProps.props, props)) : null;
};
var Tooltip = exports.Tooltip = function Tooltip(props) {
  var scrollLeft = props.scrollLeft,
    clientX = props.clientX,
    clientY = props.clientY,
    boundingClientRect = props.boundingClientRect,
    height = props.height,
    width = props.width,
    _props$nonScrollableW = props.nonScrollableWidth,
    nonScrollableWidth = _props$nonScrollableW === void 0 ? width : _props$nonScrollableW,
    xScale = props.xScale,
    yScales = props.yScales,
    series = props.series,
    tooltipFormatters = props.tooltipFormatters,
    padding = props.padding,
    tickYFormat = props.tickYFormat,
    tickXFormat = props.tickXFormat,
    isActive = props.isActive,
    padOffset = props.padOffset;
  if (!tooltipFormatters) {
    return null;
  }

  // If no data then don't show any tooltip
  if (series[0].data.length === 0) {
    return null;
  }
  var _React$useContext = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext.timezone;

  // `left` is the fixed left without the scroll used to position the tooltip
  var left = padOffset + scrollLeft + clientX - boundingClientRect.left;
  if (left < 0) {
    return null;
  }

  /*
   * `leftFromOrigin` is the left with scroll (from starting of x axis) used to
   * find out the x timestamp at a distance x from starting of x axis
   */
  var leftFromOrigin = scrollLeft + clientX - boundingClientRect.left;
  var top = clientY - boundingClientRect.top;
  var context = {
    scale: xScale,
    left: leftFromOrigin,
    top: top,
    timezone: timezone,
    series: series,
    tickYFormat: tickYFormat,
    tickXFormat: tickXFormat,
    height: height,
    width: width,
    yScales: yScales
  };
  var xAxisTimestamp = tooltipFormatters.getXFormatter(context);
  if (!xAxisTimestamp) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_StandardTooltip.StandardTooltip, {
    isActive: isActive,
    cursorXPosition: left - scrollLeft,
    cursorYPosition: top,
    padding: padding,
    chartHeight: height,
    chartWidth: width,
    position: clientX - boundingClientRect.left > nonScrollableWidth / 2 ? "left" : "right",
    renderContent: function renderContent() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, xAxisTimestamp), /*#__PURE__*/_react["default"].createElement("div", null, tooltipFormatters.getYFormatter(context)));
    },
    data: []
  });
};